import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import ScrollToTop from "./helpers/scroll-top";
import { BrowserRouter, Switch, Route, useHistory } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { multilanguage, loadLanguages } from "redux-multilanguage";
import { connect, useDispatch } from "react-redux";
import { BreadcrumbsProvider } from "react-breadcrumbs-dynamic";
import { Navigate } from "react-router-dom";

//import { createBrowserHistory } from "history";
// home pages
import HomeFashion from "./pages/home/HomeFashion";
//import HomeElectronics from "./pages/home/HomeElectronics";
//import HomeFurniture from "./pages/home/HomeFurniture";
//import HomePlants from "./pages/home/HomePlants";
//import HomeOrganicFood from "./pages/home/HomeOrganicFood";

// shop pages
//import ShopGridStandard from "./pages/shop/ShopGridStandard";
//import ShopGridFilter from "./pages/shop/ShopGridFilter";
//import ShopGridTwoColumn from "./pages/shop/ShopGridTwoColumn";
//import ShopGridNoSidebar from "./pages/shop/ShopGridNoSidebar";
import ShopGridFullWidth from "./pages/shop/ShopGridFullWidth";
//import ShopGridRightSidebar from "./pages/shop/ShopGridRightSidebar";
//import ShopListStandard from "./pages/shop/ShopListStandard";
//import ShopListFullWidth from "./pages/shop/ShopListFullWidth";
//import ShopListTwoColumn from "./pages/shop/ShopListTwoColumn";

// product pages
import Product from "./pages/shop-product/Product";
//import ProductTabLeft from "./pages/shop-product/ProductTabLeft";
//import ProductTabRight from "./pages/shop-product/ProductTabRight";
//import ProductSticky from "./pages/shop-product/ProductSticky";
//import ProductSlider from "./pages/shop-product/ProductSlider";
//import ProductFixedImage from "./pages/shop-product/ProductFixedImage";

// blog pages
//import BlogStandard from "./pages/blog/BlogStandard";
//import BlogNoSidebar from "./pages/blog/BlogNoSidebar";
//import BlogRightSidebar from "./pages/blog/BlogRightSidebar";
//import BlogDetailsStandard from "./pages/blog/BlogDetailsStandard";

import CatalogFlip from "./pages/shop/CatalogFlip";

// other pages
import About from "./pages/other/About";
import Contact from "./pages/other/Contact";
import MyAccount from "./pages/other/MyAccount";
import LoginRegister from "./pages/other/LoginRegister";
import ForgotPassword from "./pages/other/forgotPassword";
import ResetPassword from "./pages/other/resetPassword";

import Cart from "./pages/other/Cart";
import Wishlist from "./pages/other/Wishlist";
//import Compare from "./pages/other/Compare";
import Checkout from "./pages/other/Checkout";

import NotFound from "./pages/other/NotFound";

import useToken from "./hook/useToken";
import "./global";
import PreCheckout from "./pages/other/PreCheckout";
import PrivacyPolicy from "./pages/other/Privacy_policy";
import MyDocuments from "./pages/other/MyDocuments";
import MyPriceList from "./pages/other/MyPriceList";
import { CircularProgress } from "@material-ui/core";
import { fetchUser, saveUser } from "./redux/actions/userAction";
import {
  saveProducts,
  saveProductsWithoutToast,
  fetchProducts,
} from "./redux/actions/productsAction";
import { Modal } from "react-bootstrap";
import { SAVE_CART } from "./redux/actions/cartActions";
import { SAVE_WISHLIST } from "./redux/actions/wishlistActions";
import ShopCatalogueFlip from "./pages/shop/ShopCatalogueFlip";
import { resetCookieConsentValue } from "react-cookie-consent";
import Ritiri from "./pages/other/Ritiri";
import CondizioniVendita from "./pages/other/CondizioniVendita";
import PersonalizzaBanners from "./backconfig/banner/PersonalizzaBanners";
import Tutorial from "./pages/other/Tutorial";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
//import ForSaveTmp from "./pages/other/ForSaveTmp";
import "./style.css";
import Colors from "./pages/other/Colors";
import PersonalizzaHomepage from "./backconfig/homepage/PersonalizzaHomepage";
import MyShippings from "./pages/other/MyShippings";
import MyLastPurchases from "./pages/other/MyLastPurchases";
import OtpDialog from "./pages/other/modals/OtpDialog";
import MyScadenziario from "./pages/other/MyScadenziario";
import MaintenanceAlertBanner from "./components/banner/MaintenanceAlertBanner";
import MaintenanceFullscreenModal from "./components/maintenance/MaintenanceFullscreenModal";

const parseTime = (val) => {
  if (!val) return 0;
  return typeof val === "number" ? val : new Date(val).getTime();
};

const dalTime = parseTime(window["configPegaso"]?.inManutenzioneDal);
const alTime = parseTime(window["configPegaso"]?.inManutenzioneAl);

const inManutenzione =
  window["configPegaso"]?.inManutenzione === 1 ||
  (dalTime > 0 && alTime > 0 && Date.now() >= dalTime && Date.now() <= alTime);
const timerLogin = window["configPegaso"].timerLogin;

const App = ({ location, products, userData }) => {
  const isLoggedUser =
    userData?.user?.user &&
      (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;
  const visualizzaPrezzi = isLoggedUser || global.visualizzaPrezziLogOut;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;
  const prodottiSenzaLogin = global.prodottiSenzaLogin;

  const dispatch = useDispatch();
  const history = useHistory();
  const [showDialogUpdate, setShowDialogUpdate] = useState(false);
  const [refreshCheckout, setRefreshCheckout] = useState(false);

  const { token, setToken, setLastLogin, removeToken, setRefresh } = useToken();
  const [showDialogManutenzione, setShowDialogManutenzione] = useState(
    inManutenzione == 1 ? true : false
  );
  const closeDialogUpdate = () => {
    setShowDialogUpdate(false);
  };

  useEffect(() => {
    if ((products.length = 0)) {
      //history.push("/login")
    }
    if (!sessionStorage.getItem("personal")) {
      //sessionStorage.setItem("token", 0)
    }
    dispatch(
      loadLanguages({
        languages: {
          it: require("./translations/italian.json"),
          /*en: require("./translations/english.json"),
          fn: require("./translations/french.json"),
          de: require("./translations/germany.json")*/
        },
      })
    );

    handleSubmit();
    return;
  }, []);

  const clearCacheData = () => {
    try {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    } catch (error) { }

    resetCookieConsentValue();
    const cookies = document.cookie.split(";");
    //console.log(cookies)
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
    console.log("Complete Cache Cleared");
  };

  const canRefreshProduct = () => {
    const _pathLocation = window.location.pathname;
    if (_pathLocation.includes("personalizza")) return false;
    return true;
  };

  useEffect(() => {
    clearCacheData();
    //handleSubmit()
  }, [window.location]);

  useEffect(() => {
    sessionStorage.setItem("First", 1);
    var informazioni = global.informazioni;

    document.documentElement.style.setProperty(
      "--theme-color",
      informazioni.backgroudMenu
    );
  }, []);

  const handleSubmit = async (e) => {
    if (inManutenzione) return;

    const time = Date.now() - window.localStorage.getItem("lastLogin");
    console.log(time > timerLogin);
    if (time > global.timerLogin) {
      if (localStorage.getItem("token") != "0") {
        setToken(0);
        //history.push(process.env.PUBLIC_URL + "/shop-grid-full-width?name=" + queryText)
        window.location.replace(
          process.env.PUBLIC_URL + global.urlRedirectAfterLogin
        );
        return;
      }
    }

    var username = localStorage.getItem("username");
    var password = localStorage.getItem("password");
    var credentials = { username, password };

    var risultatoUser = username
      ? await fetchUser({ username, password })
      : { user: { IDCli: 0, IDAge: 0 } };
    dispatch(saveUser(risultatoUser));
    if (risultatoUser.user.cart)
      dispatch({
        type: SAVE_CART,
        payload:
          risultatoUser.user.cart /*JSON.parse(risultatoUser.user.cart) */,
      });
    if (risultatoUser.user.wishlist)
      dispatch({
        type: SAVE_WISHLIST,
        payload:
          risultatoUser.user.wishlist /*JSON.parse(risultatoUser.user.cart) */,
      });
    var jUser = risultatoUser?.user;

    if (
      canRefreshProduct() ||
      !products ||
      !products.item ||
      products?.item?.length() === 0
    ) {
      setShowDialogUpdate(true);
      var risultatoProducts = await fetchProducts({
        ...credentials,
        recommended: jUser?.jsonVendite,
      });
      var Errore = risultatoProducts?.Errore;
      if (Errore && Errore != "") return;
      dispatch(saveProductsWithoutToast(risultatoProducts));
    }

    setShowDialogUpdate(false);
    setRefresh(false);
    setRefreshCheckout(false);
    localStorage.setItem("lastRefresh", Date.now());

    var token = jUser ? (jUser.IDCli == 0 ? jUser.IDAge : jUser.IDCli) : "";

    setToken(token);
    setLastLogin();

    if (
      window.location.pathname.includes("checkout") &&
      !window.location.pathname.includes("precheckout")
    ) {
      setRefreshCheckout(true);
    }
  };
  var informazioniDGA = require("./data/informations/informazioniDGA.json");
  var informazioniMondoCarta = require("./data/informations/informazioniMondoCarta.json");
  var informazioniBetaRicambi = require("./data/informations/informazioniBetaRicambi.json");
  var informazioniSpotClub = require("./data/informations/informazioniSPOT.json");
  var informazioniRennova = require("./data/informations/informazioniRennova.json");

  var informazioni = {};
  switch (global.aziendaID) {
    case 1:
      informazioni = informazioniDGA;
      break;
    case 2:
      informazioni = informazioniMondoCarta;
      break;
    case 3:
      informazioni = informazioniSpotClub;
      break;
    case 4:
      informazioni = informazioniBetaRicambi;
      break;
    case 6:
      informazioni = informazioniRennova;
      break;
  }
  global.informazioni = informazioni;
  //const [token, setToken] = useState(""); non posso utilizzare gli state perkè quando aggiorno pagina perdo il login
  const ModalUpdate = () => {
    return null;
    return (
      <Modal show={false} transparent={true} size="xl">
        <div
          style={{
            textAlign: "center",
            font: "20px Helvetica, sans-serif",
            color: "rgb(0, 0, 0)",
            padding: "20px",
          }}
        >
          {" "}
          <img
            style={{ width: "100px" }}
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAChCAMAAABK+nL1AAAA81BMVEUAAAD///9ytivjBhO5ubn7+/vV1dV1uywdLgsUFBRTU1Ovr68aGhpgYGC3BQ/Dw8MIDQNinSU8PDw0NDTu7u7iBRJQgR4mJiZFbRnpBhOioqIZGRmJiYnq6uoNDQ1AAQVyAwrS0tI8YBazs7NJSUl+fn7h4eE1NTUtLS0/Pz9lZWWSkpIhISGAgIBUVFTLy8tvb29trinSBRHEBRAPGAV/AwoZAAI1VRQ1AQSZmZldlSMhNQytBA4mAAMcAQINFQWRBAwTHwdOAgZhAgieBA1WiiBKdRw7AQUsRxCLBAtdAgc3WBRKAgYgNAwOAAAtAQMoQA98MVN1AAASNElEQVR4nO2dCZuayBaGsRUNKDFRjLGlSdsi4o6dZWIyyWRf53bm//+aCxRLUZxTFEhP7k38niczMUJRvFadOnVqk6STTjrppJNOOumkk07639G9Iqr20cqw5x66tl7zpNu7tqHNh0q1j6hWd+6L68WLjx8/fX9ZDbK+0bXlGivd7q4WlaQf6fMjRJ+Lp3WndVZMrVZr//DOkcCUmZ7hlEg+DM3j0k/0fITqBrzBVBQFe3phWATY/sGX8i+w7GaLFKOJMS6fPq2vozqmS+j62aQ77TYNOLFSsIj+KJd9lVeoKK0qKV04q8GfwOU7e+3912zo4MOPgNXal8C1nYih8qTPjsf1bTRAaV0/y1w+bUqbaXs6kxoT6NlHwPK0v1Ms74o4Kl8X/XKIEj1GUdXro2/s1Y5sSQ3XNGuWWXOA1I6Ddda6KmLqtVxbxco4rnC9usYLVr3+mL3cqplS41zbXAwlewskdySss7MX4rQaRVF5so+i9Z6DyitaryBYK2PiOXu6ehuwzvZPxDK+tkuw8vyIY6riXT6sr2wWZVdqLKWdKw1rw1uBJWi45oKNYJaWVZrVa7wt9DV4zLpaG9mcWdKw3bfbUHoVwDrb/5Wf70VJVL5K03rDh1Uf/GDvWOlbzym17AaYXhWwBGriorBpp6RDLZOAbnjWPaiHl5l75kaj0TggPa5KYJ19zMn28AhUvsq58+/yYNWviyVYDazWQ+5D1mXtVaRdKVhv8lgNRsV609XAOjv7h/eQyZGsPH+rDKzrPFj1OtTluX1Y9znPOD+aVSkj/4jT1YmKFtDl+Rdgtb6jj9hWwKpmF48KPq7nwqoP/v4ZsM5amCdvlnNGWblFWb3KL1ie3vwUWGefkCdUUQl9Fe33PBVA5RWtnwMLcU17uRT0C9vTRZ4nBvrUuG7uihSswejd0bBatARhteDo1pSPQD5XnbFfaDq92QWfKdRbw/VaqGABoYeisO4/SOnFfr8XKVpQ+nx3VE67BC7XH5sVgvU0p6sTFa0BG3ooCusBe9W9t/9cvcgrYi3I1+ryXn/KFpbOgVe0CsESqYQBrcuqYQV6+yKH1ovsPX0eK8jTdDnXQ/E4TO+E2kJfBfzSArAk6SW/dAEmntcUHsBnbHFD3xR/LelPQVSe4CExSIVgSdJDLq3/sJcrHB8La9009A5Z3MQ/48aTU9UQCD1gKghLuuLRumKv5vgNF6hLjtutpfBr/S1m3gOJhx6KwpK+c2hljBanFnI88h12z7nwaxWohQVCD4VhSR9xWC32WpwVr2mzMLNli77VDWjeB3W4t8iG4lEVh/UEL1otxmhxYsnQ4EkkvDcp2pt+CsIawU59NhSPqTgsTkVsMUYLtz4X3J7eCrtNE3wr0LwPRn/Doz2ZITFMJWBJ99GixRitJgpryn1A/xyRIKzncFM4QGKnmSExTGVgXaGw0j2eMd7ZKxxwKaRLkEn9jfQNpjgSTLcMrDs4rJRb2sf9y5LjNYJC4snvpFeghRcOPZSBJaHd6v1b+jILZVUrSUFMn2En6/oVilGwy1MK1gPMxO9TzSHez+uWxCCmP2FYfjAGjkWIhuJLwfqCtoepwAPeGJYarBHV6wFomQIzjsSaR4+EUi4FC3e1UpMn8VkzReIHhQVb8cHouf8lUg8/CKVcCpaEwkpFS/Fe9K3a9w8wjwHvS2Q2LqNysFALn4KFxz0rm4wM6AbBQZyp98i3lyJJl4OFuqWp0UOUFdQYLtqFNQWnbr1HzBLpLiP+qlgo/qfAkoEk8TAWLnCYGrZKUYN3gxit68zso38Xlom+JBRyqArWZ7hgDe6G3yN+Rf39rcFCbRYNS/kpsL7CLOpPw+/fIbDuAmlVAwtjlTLwOKyL24N18xhxHOJqhsAaCfilt+g6/BRYPxAWSewYDqIOREIPpWC9FXJKcVi3aOA/wLBGT+MrLuErBgKzHm6zu4O/5a3BusEqWRLfw4Jdg/wuTylYn8Q60vhbAk5pNbDeI8WGihyjo2RPM6lVAkswRFMonFUNLGSVwOBD/jUCfmkZWG9xWKngH943BMLDlcB6jU0jpb0ozGiNcv3SMrC+YKyYsDI6/geN3FcC6xvCoU4PSbxGpkGMckMPZWDhI4fpabj4ECswAFgJLGzFXHrQGSt+uaGHErBwx4GZDr/BXzNr4auA9QPp6jAxBXTqVl6XpwQsfCSMmaHFmaacNc1VwEKCVax3/hyDlVcPi8P6A2XFzlju4c3h6jZg3WBOAdPOPcPq4XVOPSwM6y/OjElmouQQj/7tMvWwAliPsGlGbE8Gcx7yhsSKwrrHm13KzO7mzYBfswlvLyihlPXUVQwsbK3OgN3RAbkuN/RQENYT3GCdMcMVEnedb6YemuNECto0aGNaTPEUnb+GajB6XSGslzxUjP8u8SeIcsPwqIfGm3zD25ZAVPwuTxFYL9HBVaLMYic87oDNKCVy0Lt4sHjbEogWrbtcEy8M6973vLnwwKJDfBpNTc9YrUT4fHAOrB/w2GoxWPxZ8fCigStGnz7u81datLKLf3n1EJ91xHE5OLCQqTPFNOL6pdWt3YHW/g55C3I2WJ445ZEDi78tgai4s3ErhPUym7qJ96XxPQh4c+dxWM8KzE/GFQ7y3zqs+9CCwxnnxRFanB4lD9bXCtpCX7wuT3WwwDXl+NhhICCuxcXLgVURqwGvy1MdLHglq8GnNe0wcHP2q0FhvRNY4ytGixOKr2yNNLKXlpm3S8GG8k7N3OXUKKwPFbHizoqvbPU9tkSatygukNzYqI5iSh3L4DSDObCwKQwlxBkSqwoWugVgJxdAEWGwiqzVyREn9FDRjiGc/VV4jmllsKpxsojw0EM1sPa8Hcd4vlZRIfMrX1VXsLwuDxp6qAYWd3OV/PX34kKWWGDbEgzq+DalqK8xyOwFWCUsdskOK66bWQUsfFuC60tUyKyIOscvrQJW7qSbMpv9FYH1CmPF6xdz+keYX3o8rFb+FokKf8eGo2GhY1sD3qQrLP41QBEfD4u3v1GkzjEbs+XDQq0PN5aHx3Sw0MOxsFofhbbedApvN6aDdReEhW9LwI0Sf0YZY6GHY2Hl2quIVlFYLhipAWHhThYv3oIPH6KQj4QlvrvysNjOUBM4rAXBeo1uS5Czrh5ddY5V36Ng3RfczzUQNxDISjaltiisd2htuuTnCJlz4wkZEisPq7Xn74qYlSFs5v3NNsHtkSBYaAHJnRWDw4LrYWlYrQdFihXRMD+sQMqVvzWIKCxsGqnAkkt89wc49FAOVmv/seDm5qE2Ih7XJNiRQBQW7mRd5uUGW0DgL9SvClZr/50dexbW2M2ti+Ge+aKwsDZtkN0MmBU6qxLp8hSGtd8/KFeoYrm8HevkSbQ7DzjSmoWFTp0R2GPmBnc6HkO+/51WAd1/cPVP6TJFqTdDWkZ91YsvAi/Jwnp/F5PA0qVL9Oa7ULF88lBIV398uSOwN3cBaW1dlqkiJst6OzU0toGWGPaw5H55KX11OTOM1WplzJYWZ+7DSSeddNJJJ5100v+j/NNATsoouwTEV3XDVL+U4CNGfjlY1QwkwTt8/XKwqjnZ4DeBxd0oXFi/CaxgHbtsByp/ONLvAcsO1rFfOIpiKmYH3R42T78IrFQUjJHe3R2kw06vXaylzlBxlHHOBGBUKCzd8v6jksmfdjNRnCk9+AiNkpILmc+T6LWCDzqTKrlEpm5PfcGvOfJh25v3VGqiauPgK/zJw5P2lJm+ljTDOliGEWYjUvQSmRw1m6mxFLxkaVLNCBeBzOnvhg2ZygOw1jTcVCZ+jEx2ig7HRyfBB791ym56YVOXp8Q99CJZShYPwZKJk2oEy1TnmrOU5LU0t4bboWVkNqBaXmTeU8q+Hw6rKalmeCkTt13YXFhh5uOyLpNp7fMQlhnByu43Z1OXC8Oiw85LGJaytGa9jenBspZ9t69lYUmmkX1POsUcWP4pLTUQFpnQgcIKIcTnxYRvbzZvBVY6b0sQltkfLjoLv2S55+pUPd9AW5sdjoJVi3cVzyTicmDF2YjqYfT2xm3AYrpr4S/CwtIsdz6LStZ8CZSsIL/HwDIjvzebiI3Dik8ujQZEo7cf3wKszGGjGgRLcbcra6V4sBae7XK2MCzrKFjz6HWziWxwWPGKwWh1Uvz2UzFYwPGhKKxwS5ahpkV5hGCZam/pLP2SpXolrOfCsMyjYMW+C0nED1K0w1NcVRmDlSyBi86njWENIVibJAIyDW6Q+x1fpE00g7+bKKzz+Elyl8o6C2s+tNZWaLPa6iG2Weu2/9zw5zWbqhI8jnwc+38dp1Y38GDp0ZB6L/nNwsanj8OK1yiZLKxgPJmFhZ2xZmd/WEBunG40ML0BYCmutVkYZtZ1cGQaQpSV5JdlxIHlrhXiJKRgkZdY6xgsKubTZWHNCsBqwskzIoBILlfJHVlYBoHlG3rKwEezWslUishNI7AARxiHdZBmjfUwA4skNUZhBWcGOQ71XQKrUzksckIR2ZD/YufLTmBtI1jmwlGHql8NYw8+DUtNZaUErMXCd7d3GVgKH1bAYrmk7qCat2nVsMI95PtMvIq8vEX2XWmHHnxg4D3nlDLwESxiWyLLWByW7Hi2zSbeQ7ZkodWQvGObnPm1o2CZYdFiYZ3rseRsQnmwkkq/pHupzDqxsaG11fbYg9XbOpqjZmAFBSDeJac4rJrl+N82WVgkew5m4Inh0EleNhQsN/zxOK5DqpCJwdIpp8wx4u4oA4t2HdIli850bNJLwGpLi1loDShY4aFvFgYryOY6PGudHFlFYK0CW7zkwUoFhsRgpY+fib1oFpbX3VkvAJtl9jwtwqk6cVUuAavWXszD6YsElrbdbtXQMXARp5SckeqGlpec2E5gGUG4oaNXDIs5sU+TIViKq0atIdaRpo+oLAMrGRPJerZTBBbZILkbfUv1Xww5aCHbzWph1fR0XGUGwtpo59Y5v7tDnbpYApZ+Qf5AsPydikBYQXjGvIioGRQsUmPWdmlYyW6T6ZWdy1QAbALAMnuRB68Zi5W1gWBREzBLwHK9LLm0zWJSBmEFV/ptDKmPDg2L8FuVNvDJ4e3MQUf2ipog2INgxX7WdtYzFmDfkOpSlYClea3Dcg7CCso6CCv4N1WOu4gyBYt4M8PSfhYKy9MuMqbkLDICyzE2ngyNqoZMa0gr6d9UCWtNmg0IFnGv1ltV3ZIf+5yGRZ01WzUsr96TIiuZkxrjwXf9SOmGREpVd07DUrTlcqmF6cZFqwpYli/VjdKEYGUmWas0LDmpeBXBahq+pnSGgndmow7Oej6eS0DfkDRhc5ptOZtlel2ejJ+VCIAlZ8Yg/EfGsKjNsUrBiuMZ8eGb7RQ7B4WlLdy5C8SzQg+evMr4CFhTqbMOO+KisOzMwIzfhUhgJe1ZGVhyZugq7E5EpwAGNjFYlMdGHQztnHR34KgDCSvFO+SUgFVruMswaMGBpdqx5CSinGhKw6otsrAOSQI2PUgn5GeFo247+pWbWVim5XWkNSlrs1IhmmP6hpQ4sCQzlg0dfamlYMUmPoFlUqLDkmJOKWlGyBJPsnFIJ2kNqdGddY+M7rB9w5DINsachtVWOh2zvfAMkuF3pXBY9mS3a+bDSmSHnfdZKPJDp2DFvhUcgy8OKzrmr69FrhXlZyXVcLZdWQclrIYALDdBnoLVPCzG5/ZQWnmvduAaeKmjmNMisOwkt75IGzNJwYpGrqqCZZtsGlM+rHTfMIIVtDwmFM9yPb967ThNSeHCWnqtw1ArAOtik37jZfiRhhW9XFWwMs4K6Q7Dg6w134NfGItZBtYh4czC8hyozsFUnQUflnlYmbmtIQ3LiTlQORimYEUmvjJYejrqEBrpjIHv+wbe+1vQ3cnCaqRynoHVHErteU41dDqBOywKa0cch7hdJ1NAFDsFa1cxrLRvF+Y3DasbuQ5ewXaGnvwuSBoWMSDRXkIpWH413B2kGh+WXw3XJOJhKZ5YWF1TSclsd/z/UUNIa//zuCs7/rfxVABybZRqKoUULJP9F4yWEXWjx27U3JOOaeSsnkvDcV/pp15AD3K/iG4Ish7CrQVfzclXtod/osvNmj/5iANL8R5Kflk5UCaXjDKXRZ9T/5xcxN7PPAJ+KKimoVmaMUku1tMbyNvBdK30hD8ZyRXvyRzXYUf+nBTrF5km+e/oBKuAYFjcaYm/ryYgrJNOOumkk0466aSTTvo5+i9hAiv7gIbMOAAAAABJRU5ErkJggg=="
          />
          <h4>Attendi</h4>
          <CircularProgress />
        </div>
      </Modal>
    );
  };
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = informazioni.favicon;
  }, []);
  return (
    <ToastProvider placement="bottom-left">
      <MaintenanceFullscreenModal
        show={inManutenzione}
        title="Sito in Manutenzione Programmata"
        message="Stiamo effettuando interventi di manutenzione e aggiornamento ai nostri server per offrirvi un servizio sempre migliore."
        timeRange="Dalle ore 20:00 alle ore 24:00 del 2 Ottobre"
      />
      <MaintenanceAlertBanner
        message={
          window["configPegaso"]?.avvisoManutenzione ||
          "Il sito è regolarmente attivo. Si avvisa che il giorno 2 Ottobre dalle ore 20:00 alle 24:00 sarà effettuata una manutenzione programmata."
        }
        expireAt={
          window["configPegaso"]?.avvisoManutenzioneScadenza ||
          "2026-10-02T20:00:00"
        }
      />
      <ModalUpdate />
      <OtpDialog />
      <BreadcrumbsProvider>
        <BrowserRouter>
          <ScrollToTop>
            <Switch>
              {/* Homepages */}

              {/*<>

              <Route
                path={process.env.PUBLIC_URL + "/home-electronics"}
                component={HomeElectronics}
              />
              
                <Route
                  path={process.env.PUBLIC_URL + "/home-furniture"}
                  component={HomeFurniture}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/home-plants"}
                  component={HomePlants}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/home-organic-food"}
                  component={HomeOrganicFood}
                />
                  </>*/}

              {/* Shop pages */}

              {/*<>
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-standard"}
                component={ShopGridStandard}
              />
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-filter"}
                component={ShopGridFilter}
              />
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-two-column"}
                component={ShopGridTwoColumn}
              />
              <Route
                path={process.env.PUBLIC_URL + "/shop-grid-no-sidebar"}
                component={ShopGridNoSidebar}
              />
                </>*/}

              {/*<Route
                path={process.env.PUBLIC_URL + "/shop-grid-right-sidebar"}
                component={ShopGridRightSidebar}
            />*/}

              {/*<Route
                path={process.env.PUBLIC_URL + "/shop-list-standard"}
                component={ShopListStandard}
          />*/}

              {/*<Route
                path={process.env.PUBLIC_URL + "/shop-list-full-width"}
                component={ShopListFullWidth}
        />*/}

              {/*<Route
                path={process.env.PUBLIC_URL + "/shop-list-two-column"}
                component={ShopListTwoColumn}
              />*/}

              {/*<Route
                path={process.env.PUBLIC_URL + "/product/:id"}
                exact
                component={Product}


              render={routeProps => (
                <Product {...routeProps}/>
              )}
              />*/}

              {/*<>
                <Route
                  path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
                  component={ProductTabLeft}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
                  component={ProductTabRight}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/product-sticky/:id"}
                  component={ProductSticky}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/product-slider/:id"}
                  component={ProductSlider}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
                  component={ProductFixedImage}
                />


                <Route
                  path={process.env.PUBLIC_URL + "/blog-standard"}
                  component={BlogStandard}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
                  component={BlogNoSidebar}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
                  component={BlogRightSidebar}
                />
                <Route
                  path={process.env.PUBLIC_URL + "/blog-details-standard"}
                  component={BlogDetailsStandard}
                />
                <Route
                path={process.env.PUBLIC_URL + "/compare"}
                component={Compare}
              />
            </>*/}

              {/* Other pages */}

              {
                <Route
                  path={process.env.PUBLIC_URL + "/wishlist"}
                  component={Wishlist}
                />
              }

              {global.aziendaID == 1 ? (
                <Route
                  exact
                  path={process.env.PUBLIC_URL + "/"}
                  component={HomeFashion}
                />
              ) : (
                <Route exact path={process.env.PUBLIC_URL + "/"}>
                  <Redirect to="/shop-grid-full-width" />
                </Route>
              )}

              <Route
                path={process.env.PUBLIC_URL + "/home-fashion"}
                component={HomeFashion}
              />
              <Route
                path={process.env.PUBLIC_URL + "/redirect"}
                component={null}
              />
              <Route
                path={process.env.PUBLIC_URL + "/CatalogFlip/:page"}
                component={CatalogFlip}
              />
              <Route
                path={process.env.PUBLIC_URL + "/about"}
                component={About}
              />

              <Route
                path={process.env.PUBLIC_URL + "/contact"}
                component={Contact}
              />

              <Route
                path={process.env.PUBLIC_URL + "/login-register"}
                component={() => (
                  <LoginRegister
                    setToken={setToken}
                    setLastLogin={setLastLogin}
                  />
                )}
              />

              <Route
                path={process.env.PUBLIC_URL + "/forgot-password"}
                component={ForgotPassword}
              />
              <Route
                path={process.env.PUBLIC_URL + "/reset-password/:data"}
                render={(routeProps) => (
                  <ResetPassword
                    {...routeProps}
                    key={routeProps.match.params.data}
                  />
                )}
              />

              <Route
                path={process.env.PUBLIC_URL + "/login"}
                component={() => (
                  <LoginRegister
                    setToken={setToken}
                    setLastLogin={setLastLogin}
                  />
                )}
              />

              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/cart"}
                  component={Cart}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/my-account"}
                  component={MyAccount}
                />
              )}
              {!isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/my-account"}
                  component={null}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/ritiri"}
                  component={Ritiri}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/my-documents"}
                  component={MyDocuments}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/my-last-purchases"}
                  component={MyLastPurchases}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/shippings"}
                  component={MyShippings}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/my-pricelist"}
                  component={MyPriceList}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  component={() => (
                    <Checkout
                      location={location}
                      refreshCheckout={refreshCheckout}
                      setRefreshCheckout={setRefreshCheckout}
                    />
                  )}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/precheckout"}
                  component={PreCheckout}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/privacy-policy"}
                  component={PrivacyPolicy}
                />
              )}
              {isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/condizioni-vendita"}
                  component={CondizioniVendita}
                />
              )}
              {!isLoggedUser && (
                <Route
                  path={process.env.PUBLIC_URL + "/checkout"}
                  component={() => null}
                />
              )}

              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                isLoggedUser && (
                  <Route
                    path={process.env.PUBLIC_URL + "/consigliati/:search"}
                    component={ShopGridFullWidth}
                  />
                )
              }
              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                isLoggedUser && (
                  <Route
                    path={process.env.PUBLIC_URL + "/consigliati"}
                    component={ShopGridFullWidth}
                  />
                )
              }
              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                !isLoggedUser && (
                  <Route
                    path={process.env.PUBLIC_URL + "/consigliati"}
                    component={() => (
                      <LoginRegister
                        setToken={setToken}
                        setLastLogin={setLastLogin}
                      />
                    )}
                  />
                )
              }

              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                !isLoggedUser && !prodottiSenzaLogin && (
                  <Route
                    path={
                      process.env.PUBLIC_URL + "/shop-grid-full-width/:search"
                    }
                    component={() => (
                      <LoginRegister
                        setToken={setToken}
                        setLastLogin={setLastLogin}
                      />
                    )}
                  />
                )
              }
              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                !isLoggedUser && !prodottiSenzaLogin && (
                  <Route
                    path={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                    component={() => (
                      <LoginRegister
                        setToken={setToken}
                        setLastLogin={setLastLogin}
                      />
                    )}
                  />
                )
              }
              {
                //(((token != undefined) && (token != "") && (token != "0") && sessionStorage.getItem("personal")) && !prodottiSenzaLogin) &&
                !isLoggedUser && !prodottiSenzaLogin && (
                  <Route
                    path={process.env.PUBLIC_URL + "/shop-catalogue"}
                    component={() => (
                      <LoginRegister
                        setToken={setToken}
                        setLastLogin={setLastLogin}
                      />
                    )}
                  />
                )
              }
              {!isLoggedUser && !prodottiSenzaLogin && (
                <Route
                  path={process.env.PUBLIC_URL + "/product/:id"}
                  component={() => (
                    <LoginRegister
                      setToken={setToken}
                      setLastLogin={setLastLogin}
                    />
                  )}
                />
              )}

              {(isLoggedUser || prodottiSenzaLogin) && (
                <Route
                  path={
                    process.env.PUBLIC_URL + "/shop-grid-full-width/:search"
                  }
                  component={ShopGridFullWidth}
                />
              )}

              {(isLoggedUser || prodottiSenzaLogin) && (
                <Route
                  path={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                  component={ShopGridFullWidth}
                />
              )}

              {(isLoggedUser || prodottiSenzaLogin) && (
                <Route
                  path={process.env.PUBLIC_URL + "/shop-catalogue"}
                  component={ShopCatalogueFlip}
                />
              )}

              {(isLoggedUser || prodottiSenzaLogin) && (
                <Route
                  path={process.env.PUBLIC_URL + "/product/:id"}
                  component={Product}
                />
              )}

              {
                /*userData.user.user?.IDCli === 41917 && */
                (userData?.user?.user?.IDCli &&
                  window["configPegaso"].untentiModificaBanners?.includes(
                    localStorage.getItem("IDDetCliRef")
                  )) ||
                  true ? (
                  <Route
                    path={
                      process.env.PUBLIC_URL + "/personalizzaBanners/:timeStamp"
                    }
                    component={PersonalizzaBanners}
                  //component={ForSaveTmp}
                  />
                ) : (
                  <Route
                    path={
                      process.env.PUBLIC_URL + "/personalizzaBanners/:timeStamp"
                    }
                    component={PersonalizzaBanners}
                  />
                )
              }

              {
                /*userData.user.user?.IDCli === 41917 && */
                userData?.user?.user?.IDCli &&
                  window["configPegaso"].untentiModificaBanners?.includes(
                    localStorage.getItem("IDDetCliRef")
                  ) ? (
                  <Route
                    path={process.env.PUBLIC_URL + "/personalizzaBanners"}
                    component={PersonalizzaBanners}
                  //component={ForSaveTmp}
                  />
                ) : (
                  <Route
                    path={process.env.PUBLIC_URL + "/personalizzaBanners"}
                    component={PersonalizzaBanners}
                  />
                )
              }

              {
                /*userData.user.user?.IDCli === 41917 && */
                (userData?.user?.user?.IDCli &&
                  window["configPegaso"].untentiModificaBanners?.includes(
                    localStorage.getItem("IDDetCliRef")
                  )) ||
                  true ? (
                  <Route
                    path={
                      process.env.PUBLIC_URL +
                      "/personalizzaHomepage/:timeStamp"
                    }
                    component={PersonalizzaHomepage}
                  //component={ForSaveTmp}
                  />
                ) : (
                  <Route
                    path={
                      process.env.PUBLIC_URL +
                      "/personalizzaHomepage/:timeStamp"
                    }
                    component={PersonalizzaHomepage}
                  />
                )
              }

              {
                /*userData.user.user?.IDCli === 41917 && */
                userData?.user?.user?.IDCli &&
                  window["configPegaso"].untentiModificaBanners?.includes(
                    localStorage.getItem("IDDetCliRef")
                  ) ? (
                  <Route
                    path={process.env.PUBLIC_URL + "/personalizzaHomepage"}
                    component={PersonalizzaHomepage}
                  //component={ForSaveTmp}
                  />
                ) : (
                  <Route
                    path={process.env.PUBLIC_URL + "/personalizzaHomepage"}
                    component={PersonalizzaHomepage}
                  />
                )
              }

              <Route
                path={process.env.PUBLIC_URL + "/not-found"}
                component={NotFound}
              />

              <Route
                exact
                path={process.env.PUBLIC_URL + "/tutorial"}
                component={Tutorial}
              />
              <Route
                exact
                path={process.env.PUBLIC_URL + "/colors"}
                component={Colors}
              />
              <Route
                exact
                path={process.env.PUBLIC_URL + "/scadenziario-clienti"}
                component={MyScadenziario}
              />

              <Route exact component={NotFound} />
            </Switch>
          </ScrollToTop>
        </BrowserRouter>
      </BreadcrumbsProvider>
    </ToastProvider>
  );
};

App.propTypes = {
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    products: state.productData.products,
    userData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
    saveProducts: (products, addToast) => {
      dispatch(saveProducts(products, addToast));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(multilanguage(App));
